import styled from "styled-components";

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 2rem;
  padding: 2rem;
  background: #000000;
  border: 1px solid #ffffff;
  border-radius: 0.5rem;
  text-align: center;
`;

export const CardLeft = styled.div`
  /* Removed - no image display in this design */
`;

export const CardRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  h4 {
    font-size: 1.5rem;
    font-weight: 400;
    color: #ffffff;
    margin-bottom: 1rem;
  }

  p {
    font-weight: 400;
    max-width: 600px;
    margin-bottom: 1rem;
    color: #cccccc;
    text-align: center;
    line-height: 1.6;
  }
`;

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;

  .stackTitle {
    font-weight: 500;
    font-size: 17px;
    color: #ffffff;
    margin-bottom: 0.5rem;
  }

  .tags {
    font-size: 15px;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
  }
`;

export const BtnGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
`;
